import axios from "axios";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(";").shift();
    }
    return null;
}

const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

const API_BASE_URL = isLocalhost
    ? (process.env.REACT_APP_API_URL || "http://localhost:8000/api")
    : "/api";

const API = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
});

let isRefreshing = false;
let refreshPromise = null;

API.interceptors.request.use((config) => {
    const method = (config.method || "get").toLowerCase();

    if (["post", "put", "patch", "delete"].includes(method)) {
        const csrfToken = getCookie("csrftoken");
        if (csrfToken) {
            config.headers["X-CSRFToken"] = csrfToken;
        }
    }

    return config;
});

API.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (!error.response) {
            return Promise.reject(error);
        }

        if (error.response.status !== 401) {
            return Promise.reject(error);
        }

        const skipRefresh =
            originalRequest?.skipAuthRefresh === true ||
            originalRequest?.url?.includes("/users/auth/login/") ||
            originalRequest?.url?.includes("/users/auth/refresh/") ||
            originalRequest?.url?.includes("/users/auth/logout/");

        if (skipRefresh) {
            return Promise.reject(error);
        }

        if (originalRequest._retry) {
            window.dispatchEvent(new Event("auth:logout"));
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        try {
            if (!isRefreshing) {
                isRefreshing = true;
                refreshPromise = API.post("/users/auth/refresh/", null, {
                    skipAuthRefresh: true,
                });
            }

            await refreshPromise;
            isRefreshing = false;
            refreshPromise = null;

            return API(originalRequest);
        } catch (refreshError) {
            isRefreshing = false;
            refreshPromise = null;
            window.dispatchEvent(new Event("auth:logout"));
            return Promise.reject(refreshError);
        }
    }
);

export default API;